import {BaseEntity,Column,Entity,Index,JoinColumn,JoinTable,ManyToMany,ManyToOne,OneToMany,OneToOne,PrimaryColumn,PrimaryGeneratedColumn,RelationId, VersionColumn, UpdateDateColumn, CreateDateColumn} from "typeorm";
import { QcDefect } from "../qc-defect-entity";
@Entity('qc_defect_items')
export class QcdefectitemEntity{
    @PrimaryGeneratedColumn("increment",{name:'qc_defect_item_id'})
    qcdefectitemId:number;

    @Column('int', {
        name: "qc_id"
      })
      qcId: number;

      @Column('int', {
        name:"testresult_Id"
      })
      testResultId:number;
      @Column('int', {
        name: "rejected_quantity"
      })
      rejectedQuantity: number;

      @CreateDateColumn({ name: "created_at" })
      createdAt: Date;
  
  
      @Column("varchar", {
          nullable: true,
          length: 40,
          name: "created_user"
      })
      createdUser: string | null;
  
  
      @UpdateDateColumn({ name: "updated_at" })
      updatedAt: Date;
  
  
      @Column("varchar", {
          nullable: true,
          length: 40,
          name: "updated_user"
      })
      updatedUser: string | null;
  
      // @Column("boolean", {
      //     nullable: false,
      //     default: true,
      //     name: "status"
      // })
      // isActive: boolean | null;
  
      @VersionColumn({
          default: 1,
          name: "version_flag"
      })
      versionFlag: number;
  
      

      @ManyToOne(type =>QcDefect,qcdefect =>qcdefect.qcdefectItems, {nullable:false})
      @JoinColumn({name:'qc_id'})
      qcdefectdetailsinfo:QcDefect
}